import { atom } from 'recoil';

// eslint-disable-next-line import/prefer-default-export
export const keyboardColorsMapState = atom({ key: 'keyboardColorsMap', default: {} });
